import { useEffect, useRef, useState } from "react";
import * as React from "react";

export const InputBox = ({ title, placeholder, value, onChange }) => {
    const [focus, setFocus] = useState(false)
    const inputContainer = useRef()

    useEffect(() => {
        if (focus) {
            inputContainer.current.classList.add('focus')

        } else {
            inputContainer.current.classList.remove('focus')
        }
    }, [focus])

    const changeValue = (e) => onChange(e.target.value)

    return (
        <div className={"input-wrapper"}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            ref={inputContainer}>
            <div className="left">
                <h4 className="input-title">{title}</h4>
                <input className="input-text" id="residence" name="residence" type="text"
                    placeholder={placeholder} maxLength="25" autoComplete="off" onChange={changeValue}
                    value={value}
                />
            </div>
            <p className="input-length">{`${value.length}/25`}</p>
        </div>
    )
}

// sign-card.com/

export const InputBoxWithFixedText = ({ title, placeholder, value, onChange, fixedText }) => {
    const [focus, setFocus] = useState(false)
    const inputContainer = useRef()

    useEffect(() => {
        if (focus) {
            inputContainer.current.classList.add('focus')
        } else {
            inputContainer.current.classList.remove('focus')
        }
    }, [focus])

    const changeValue = (e) => onChange(e.target.value)

    return (
        <div className={"input-wrapper"}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            ref={inputContainer}>
            <div className="left">
                <h4 className="input-title">{title}</h4>
                <div className="input-text-container fixed-text">
                    <div className="input-text-holder">{fixedText}</div>
                    <input className="input-text" id="residence" name="residence" type="text"
                        placeholder={placeholder} maxLength="25" autoComplete="off" onChange={changeValue}
                        value={value}
                    />
                </div>
            </div>
            <span className="input-length">{`${value.length}/25`}</span>
        </div>
    )
}

